import { BadRequestException } from '../services/exceptions'
import { get } from './http'

export async function setUserMonitoringConfig(obj) {
  // console.log('setUserMonitoringConfig obj:',obj)
  const objStr = JSON.stringify(obj)
  const response = await get(`/users/setUserMonitoringConfig/${encodeURIComponent(objStr)}`)
  if (response.status === 200)
    return await response.json()

  throw new BadRequestException((await response.json()).message)
}

export async function getUserMonitoringConfig() {
  // console.log('getUserMonitoringConfig ')
  const response = await get(`/users/getUserMonitoringConfig`)
  if (response.status === 200)
    return await response.json()

  throw new BadRequestException((await response.json()).message)
}

export async function monitoringTest() {
  // console.log('monitoringTest')
  const response = await get(`/numerableNews/monitoring_test`)

  if (response.status === 200)
    return await response.json()

  throw new BadRequestException((await response.json()).message)
}

// Raw (un-aggregated) AI cost data - monitoring costs per user/day plus news-summary costs per release. Developer-only.
export async function getAiCosts() {
  const response = await get(`/users/getAiCosts`)
  if (response.status === 200)
    return await response.json()

  throw new BadRequestException((await response.json()).message)
}
